import { ReactNode } from 'react';
import type { ExtraDataType } from 'watchApi/types';

// Keys to hide from the extra data display
const HIDDEN_KEYS = ['dailyImpressions'];

const rendererDefault = (extraData: ExtraDataType): ReactNode => (
  <ul>
    {Object.keys(extraData)
      .filter((key) => !HIDDEN_KEYS.includes(key))
      .map((key) => (
        <li key={key}>
          <strong>{key}: </strong>
          {extraData[key]}
        </li>
      ))}
  </ul>
);

const renderers: {
  [index: string]: (extraData: ExtraDataType) => ReactNode;
} = {
  default: rendererDefault,
};

type ViewershipDetailsExtraProps = {
  readonly extraData: ExtraDataType;
};

function ViewershipDetailsExtra({ extraData }: ViewershipDetailsExtraProps) {
  return renderers.default(extraData);
}

export default ViewershipDetailsExtra;
